import { render, staticRenderFns } from "./otaCarrier.vue?vue&type=template&id=6af1fc2c"
import script from "./otaCarrier.vue?vue&type=script&lang=js"
export * from "./otaCarrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports